import { connect } from 'react-redux'
import Header from './header'
import Footer from './footer'

const mapHeaderStateToProps = state => ({
  headerHtml: state.globalNav?.headerHtml || '',
})

export const RenderHeader = connect(mapHeaderStateToProps)(Header)

const mapFooterStateToProps = state => ({
  footerHtml: state.globalNav?.footerHtml || '',
})

export const RenderFooter = connect(mapFooterStateToProps)(Footer)
